import React, { useEffect, useState } from 'react';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import { refundPartialOrder } from 'services';
import ItemRefundReasonDropdown from './ItemRefundReasonDropdown';

const RefundItemsModal = props => {
  const [loading, setLoading] = useState<boolean>(false);
  const [itemsForRefund, setItemsForRefund] = useState<Record<string, any>[]>([]);
  const { orderId, items, setItems, onSuccess, toggleModal } = props;

  useEffect(() => {
    setItemsForRefund(items);
  }, []);
  
  const refundOrder = async () => {
    setLoading(true);
    try {
      let itemsArray: Record<string, any>[] = [];
      itemsArray = items.map(item => ({
        orderItemId: item.objectId,
        reason: item.reason,
        quantity: item.count,
      }));
      await refundPartialOrder(orderId, itemsArray);
      await onSuccess();
      showSuccess('Items refunded successfully');
      setItems([]);
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (key: string, value: string | number, id: string) => {
    const itemsArray: Record<string, any>[] = itemsForRefund.map(item => {
      if (item.objectId === id) {
        item[key] = value;
      }
      return item;
    });
    setItemsForRefund(itemsArray);
  };
  
  const renderRefundableItems = () => {
    return (
      <div className={styles['items-section']}>
        {items?.map(item => {
          return (
            <div key={item.objectId} className={styles['single-item']}>
              <div className={styles['item-detail-group']}>
                <div className={styles['label']}>Name</div>
                <div className={styles['name']}>{item.name}</div>
              </div>
              <div className={styles['item-detail-group']}>
                <div className={styles['label']}>Quantity</div>
                <input
                  type={'number'}
                  value={item.count}
                  className={'form-control'}
                  onChange={e => handleChange('count', parseInt(e.target.value), item.objectId)}
                />
              </div>
              <div className={styles['item-detail-group']}>
                <div className={styles['label']}>Reason</div>
                <ItemRefundReasonDropdown
                  value={item.reason || ''}
                  className={'form-control'}
                  onChange={value => handleChange('reason', value, item.objectId)}
                />
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  
  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Refund</div>
            <div className={styles['modal-title']}>Refundable Items</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          {renderRefundableItems()}
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={refundOrder}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default RefundItemsModal;
